import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'
import { useUserData } from '@/hooks/useUserData'
import type { UserData } from '@/types/models'

interface ArtistContextType {
  userData: UserData | null
  isArtist: boolean
  artistId: string | null
  loading: boolean
  error: Error | null
}

const ArtistContext = createContext<ArtistContextType>({
  userData: null,
  isArtist: false,
  artistId: null,
  loading: true,
  error: null
})

export const useArtist = () => {
  const context = useContext(ArtistContext)
  if (!context) {
    throw new Error('useArtist must be used within an ArtistProvider')
  }
  return context
}

interface ArtistProviderProps {
  children: ReactNode
}

export function ArtistProvider({ children }: ArtistProviderProps) {
  const { userData, loading, error } = useUserData()
  
  const isArtist = userData?.isArtist || false
  const artistId = userData?.artistId || null

  return (
    <ArtistContext.Provider value={{
      userData,
      isArtist,
      artistId,
      loading,
      error
    }}>
      {children}
    </ArtistContext.Provider>
  )
} 